import PropTypes from 'prop-types';
import React from 'react';

import { Badge } from 'twyne-new.ui';

import Group from './Group';
import { conditionsLabels } from './utils';

const propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default function Groups({ data, options, conditions, onChange, disabled }) {
  if (!options) {
    return null
  }

  const handleAddRuleRow = index => {
    data.groups[index].rules.push({})
    onChange(data)
  }

  const handleDeleteRuleRow = (index, rowIndex) => {
    data.groups[index].rules.splice(rowIndex, 1);
    if (data.groups[index].rules.length === 0) {
      data.groups[index].rules.push({})
    }
    onChange(data)
  }

  const handleDeleteGroup = index => {
    data.groups.splice(index, 1)
    onChange(data)
  }

  const handleChangeGroup = (index, group) => {
    data.groups[index] = group
    onChange(data)
  }

  return data.groups.map((group, groupIndex, { length }) => <React.Fragment key={groupIndex}>
    <Group
      key={groupIndex}
      groupIndex={groupIndex}
      data={group}
      options={options}
      condition={data.condition}
      conditions={conditions}
      onAddRow={handleAddRuleRow}
      onDeleteRow={handleDeleteRuleRow}
      onDeleteGroup={() => handleDeleteGroup(groupIndex)}
      onChange={groupData => handleChangeGroup(groupIndex, groupData)}
      disabled={disabled}
    />
    {groupIndex < length - 1 && <>
      <Badge variant='light' className='uppercase font-semibold'>{conditionsLabels[data.condition] || data.condition}</Badge>
    </>}
  </React.Fragment>)
}

Groups.propTypes = propTypes
Groups.defaultProps = {}
